<template>
    <div id="login" class="page" @click="toggleLogin">

        <div class="box login-box" @click.stop.revent="">
            <div class="content">
                <p class="title">
                    Pour visualiser les prix,
                    <br/>
                    connectez-vous ou créez un compte
                </p>

                <input type="text" placeholder="Votre e-mail" v-model="formular_autentificare.email"/>
                <input type="password" placeholder="Votre mot de passe" v-model="formular_autentificare.password"/>

                <button type="button" class="blue" @click="openSignup">Créer un compte</button>
                <button type="button" class="dark-blue" @click="loginLoginFromForm">Connexion</button>
            </div>
            <div class="footer">
                <button type="button" class="transparent" @click="openResetPassword">Mot de passe oublié</button>
            </div>
        </div>

        <div class="box signup-box" @click.stop.revent="">
            <div class="content">
                <p class="title"> Créer un compte </p>
                <input type="text" placeholder="Votre e-mail*" v-model="formular_inregistrare.email"/>
                <input type="password" placeholder="Votre mot de passe*" v-model="formular_inregistrare.password"/>
                <input type="text" placeholder="Votre nom*" v-model="formular_inregistrare.nom"/>
                <input type="text" placeholder="Votre société*" v-model="formular_inregistrare.societe"/>
                <input type="text" placeholder="TVA*" v-model="formular_inregistrare.tva"/>
                <input type="text" placeholder="Votre téléphone" v-model="formular_inregistrare.telephone"/>
                <input type="text" placeholder="Votre téléphone portable*" v-model="formular_inregistrare.telephone_portable"/>
                <input type="text" placeholder="Rue / N° de rue*" v-model="formular_inregistrare.rue"/>
                <input type="text" placeholder="Code postal*" class="half" v-model="formular_inregistrare.code_postal"/>
                <input type="text" placeholder="Ville*" class="half" v-model="formular_inregistrare.ville"/>
                <input type="text" placeholder="Site Web" v-model="formular_inregistrare.web"/>
                <input type="text" placeholder="Profession" v-model="formular_inregistrare.profession"/>
                <button type="button" class="blue" @click="loginSignUpFromForm()">Créer</button>
            </div>
        </div>

        <div class="box reset-password-box" @click.stop.revent="">
            <div class="content">
                <p class="title">
                    S'il vous plaît écrivez votre adresse e-mail et vous recevrez un lien de récupération
                </p>

                <input type="text" placeholder="Votre e-mail*" v-model="formular_resetare.email"/>

                <button type="button" @click="loginResetPasswordFromForm()">Valider</button>
            </div>
        </div>

        <div class="box confirm-password-box" @click.stop.revent="">
            <div class="content">
                <p class="title">
                    Vous avez reçu un code sur l'adresse e-mail que vous avez saisie, entrez le code et le nouveau mot de passe que vous désirez
                </p>

                <input type="text" placeholder="Votre code*" v-model="formular_confirmare.code"/>
                <input type="password" placeholder="Nouveaux mot de passe*" v-model="formular_confirmare.password"/>
                <input type="password" placeholder="Confirmer le mot de passe*" v-model="formular_confirmare.password_confirmation"/>

                <button type="button" @click="loginConfirmPasswordFromForm()">Valider</button>
            </div>
        </div>

    </div>
</template>

<script>
    import Autentification from "../services/Autentification";

    export default {
        name: "Login",
        data: function () {
            return {
                formular_autentificare: {
                    email: '',
                    password: ''
                },
                formular_inregistrare: {
                    email: '',
                    password: '',
                    nom: '',
                    societe: '',
                    tva: '',
                    telephone: '',
                    telephone_portable: '',
                    rue: '',
                    code_postal: '',
                    ville: '',
                    web: '',
                    profession: '',
                },
                formular_resetare: {
                    email: '',
                },
                formular_confirmare: {
                    code: '',
                    password: '',
                    password_confirmation: '',
                    email: ''
                }
            }
        },
        mounted: function () {
            let api_token = window.localStorage.getItem('api_token');
            this.$store.commit('setApiToken', api_token);

            // $eventbus.$on('toggle:login', function(){
            //     document.querySelector('#login').classList.toggle('opened');
            // });
        },
        methods: {
            //
            clearLogin: function () {
                var self = this;
                self.formular_autentificare.email = '';
                self.formular_autentificare.password = '';
            },
            clearSignup: function () {
                var self = this;
                self.formular_inregistrare.email = '';
                self.formular_inregistrare.password = '';
                self.formular_inregistrare.nom = '';
                self.formular_inregistrare.societe = '';
                self.formular_inregistrare.tva = '';
                self.formular_inregistrare.telephone = '';
                self.formular_inregistrare.telephone_portable = '';
                self.formular_inregistrare.rue = '';
                self.formular_inregistrare.code_postal = '';
                '';
                self.formular_inregistrare.ville = '';
                self.formular_inregistrare.web = '';
                self.formular_inregistrare.profession = '';
            },
            clearResetPassword: function () {
                var self = this;
                self.formular_resetare.email = '';
            },
            clearConfirmPassword: function () {
                var self = this;
                self.formular_confirmare.code = '';
                self.formular_confirmare.password = '';
                self.formular_confirmare.password_confirmation = '';
                self.formular_confirmare.email = '';
            },
            //
            toggleLogin: function () {
                this.clearLogin();
                $eventbus.$emit('toggle:login');
            },
            openSignup: function () {
                this.clearSignup();
                $eventbus.$emit('open:signup');
            },
            openResetPassword: function () {
                this.clearResetPassword();
                $eventbus.$emit('open:reset-password');
            },
            openConfirmPassword: function () {
                this.clearConfirmPassword();
                $eventbus.$emit('open:confirm-password');
            },
            //
            isValidEmail: function (email) {
                var re = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                return re.test(email) ? true : false;
            },
            //
            loginLoginFromForm: function () {
                var self = this;
                // preia datele
                self.formular_autentificare.email = self.formular_autentificare.email.trim().toLowerCase();
                self.formular_autentificare.password = self.formular_autentificare.password.trim();
                //
                window.localStorage.removeItem('api_token');
                // valideaza datele
                if (self.formular_autentificare.email.length === 0) {
                    $eventbus.$emit('open:alert', 'Merci de préciser une adresse e-mail valide.');
                } else if (!self.isValidEmail(self.formular_autentificare.email)) {
                    $eventbus.$emit('open:alert', 'Merci de préciser une adresse e-mail valide.');
                } else if (self.formular_autentificare.password.length === 0) {
                    $eventbus.$emit('open:alert', 'Merci de préciser une mod de passe valide.');
                } else {
                    Autentification
                            .login({
                                kta_id: '',
                                email: self.formular_autentificare.email,
                                password: self.formular_autentificare.password,
                            })
                            .then(function (result) {
                                var data = result.data;

                                if (data && data.error) {
                                    $eventbus.$emit('open:alert', data.error.message);
                                } else {
                                    window.localStorage.setItem('api_token', data.data.api_token);
                                    self.$store.commit('setApiToken', data.data.api_token);
                                    $eventbus.$emit('toggle:login');
                                }
                            })
                            .catch(function (error) {
                                console.error(error);
                                $eventbus.$emit('open:alert', 'Le formulaire comporte une erreur. Veuillez vérifier les informations.');
                            })
                            .then(function () {
                                self.clearLogin();
                            })
                }

            },
            loginSignUpFromForm: function () {
                var self = this;
                // preia datele
                self.formular_inregistrare.email = self.formular_inregistrare.email.trim().toLowerCase();
                self.formular_inregistrare.password = self.formular_inregistrare.password.trim();
                self.formular_inregistrare.nom = self.formular_inregistrare.nom.trim();
                self.formular_inregistrare.societe = self.formular_inregistrare.societe.trim();
                self.formular_inregistrare.tva = self.formular_inregistrare.tva.trim();
                self.formular_inregistrare.telephone = self.formular_inregistrare.telephone.trim();
                self.formular_inregistrare.telephone_portable = self.formular_inregistrare.telephone_portable.trim();
                self.formular_inregistrare.rue = self.formular_inregistrare.rue.trim();
                self.formular_inregistrare.code_postal = self.formular_inregistrare.code_postal.trim();
                self.formular_inregistrare.ville = self.formular_inregistrare.ville.trim();
                self.formular_inregistrare.web = self.formular_inregistrare.web.trim();
                self.formular_inregistrare.profession = self.formular_inregistrare.profession.trim();
                // valideaza datele
                if (self.formular_inregistrare.email.length === 0) {
                    $eventbus.$emit('open:alert', 'Merci de préciser votre e-mail.');
                } else if (!self.isValidEmail(self.formular_inregistrare.email)) {
                    $eventbus.$emit('open:alert', 'Merci de préciser une adresse e-mail valide.');
                } else if (self.formular_inregistrare.password.length === 0) {
                    $eventbus.$emit('open:alert', 'Merci de préciser votre mot de passe.');
                } else if (self.formular_inregistrare.password.length < 6) {
                    $eventbus.$emit('open:alert', 'La valeur du mot de passe doit être au moins 6 caractères.');
                } else if (self.formular_inregistrare.nom.length === 0) {
                    $eventbus.$emit('open:alert', 'Merci de préciser votre nom.');
                } else if (self.formular_inregistrare.societe.length === 0) {
                    $eventbus.$emit('open:alert', 'Merci de préciser votre société.');
                } else if (self.formular_inregistrare.tva.length === 0) {
                    $eventbus.$emit('open:alert', 'Merci de préciser votre tva.');
                } else if (self.formular_inregistrare.telephone_portable.length === 0) {
                    $eventbus.$emit('open:alert', 'Merci de préciser votre téléphone portable.');
                } else if (self.formular_inregistrare.rue.length === 0) {
                    $eventbus.$emit('open:alert', 'Merci de préciser votre rue / n° de rue.');
                } else if (self.formular_inregistrare.code_postal.length === 0) {
                    $eventbus.$emit('open:alert', 'Merci de préciser votre code postal.');
                } else if (self.formular_inregistrare.ville.length === 0) {
                    $eventbus.$emit('open:alert', 'Merci de préciser votre ville.');
                } else {
                    // apel
                    Autentification
                            .signup({
                                kta_id: '',
                                email: self.formular_inregistrare.email,
                                password: self.formular_inregistrare.password,
                                name: self.formular_inregistrare.nom,
                                society: self.formular_inregistrare.societe,
                                tva: self.formular_inregistrare.tva,
                                tel: self.formular_inregistrare.telephone,
                                mobile: self.formular_inregistrare.telephone_portable,
                                street: self.formular_inregistrare.rue,
                                code: self.formular_inregistrare.code_postal,
                                city: self.formular_inregistrare.ville,
                                site: self.formular_inregistrare.web,
                                profession: self.formular_inregistrare.profession
                            })
                            .then(function (response) {
                                var data = response.data;

                                if (data && data.error) {
                                    $eventbus.$emit('open:alert', data.error.message);
                                } else {
                                    $eventbus.$emit('toggle:login');
                                    $eventbus.$emit('open:alert', 'Votre compte a été créé, veuillez attendre qu\'il soit activé.')
                                }
                            })
                            .catch(function (error) {
                                $eventbus.$emit('open:alert', 'Le formulaire comporte une erreur. Veuillez vérifier les informations.');
                            })
                            .then(function () {
                                self.clearSignup();
                            });
                }
            },
            loginResetPasswordFromForm: function () {
                var self = this;
                // preia datele
                self.formular_resetare.email = self.formular_resetare.email.trim().toLowerCase();
                //
                // valideaza datele
                if (self.formular_resetare.email.length === 0) {
                    $eventbus.$emit('open:alert', 'Merci de préciser votre e-mail.');
                } else if (!self.isValidEmail(self.formular_resetare.email)) {
                    $eventbus.$emit('open:alert', 'Merci de préciser une adresse e-mail valide.');
                } else {
                    Autentification
                            .reset_password({
                                kta_id: '',
                                email: self.formular_resetare.email,
                            })
                            .then(function (result) {
                                var data = result.data;

                                if (data && data.error) {
                                    $eventbus.$emit('open:alert', data.error.message);
                                } else {
                                    self.formular_confirmare.email = self.formular_resetare.email;
                                    $eventbus.$emit('open:confirm-password');
                                }
                            })
                            .catch(function (error) {
                                $eventbus.$emit('open:alert', 'Le formulaire comporte une erreur. Veuillez vérifier les informations.');
                            })
                            .then(function () {
                                self.clearResetPassword();
                            })
                }
            },
            loginConfirmPasswordFromForm: function () {
                var self = this;
                // preia datele
                self.formular_confirmare.code = self.formular_confirmare.code.trim();
                self.formular_confirmare.password = self.formular_confirmare.password.trim();
                self.formular_confirmare.password_confirmation = self.formular_confirmare.password_confirmation.trim();
                self.formular_confirmare.email = self.formular_confirmare.email.trim().toLowerCase();
                //
                // valideaza datele
                if (self.formular_confirmare.code.length === 0) {
                    $eventbus.$emit('open:alert', 'Merci de préciser votre code.');

                } else if (self.formular_confirmare.password.length === 0) {
                    $eventbus.$emit('open:alert', 'Merci de préciser votre mot de passe.');
                } else if (self.formular_confirmare.password.length < 6) {
                    $eventbus.$emit('open:alert', 'La valeur du mot de passe doit être au moins 6 caractères.');

                } else if (self.formular_confirmare.password_confirmation.length === 0) {
                    $eventbus.$emit('open:alert', 'Merci de préciser votre mot de passe.');
                } else if (self.formular_confirmare.password_confirmation.length < 6) {
                    $eventbus.$emit('open:alert', 'La valeur du mot de passe doit être au moins 6 caractères.');

                } else if (self.formular_confirmare.password !== self.formular_confirmare.password_confirmation) {
                    $eventbus.$emit('open:alert', 'Merci pour les mots de passe, mais ils ne correspondent pas.');

                } else {
                    Autentification
                            .confirm_password({
                                kta_id: '',
                                token: self.formular_confirmare.code,
                                password: self.formular_confirmare.password,
                                password_confirmation: self.formular_confirmare.password_confirmation,
                                email: self.formular_confirmare.email,
                            })
                            .then(function (result) {
                                var data = result.data;

                                if (data && data.error) {
                                    $eventbus.$emit('open:alert', data.error.message);
                                } else {
                                    $eventbus.$emit('open:alert', data.message);
                                    $eventbus.$emit('toggle:login');
                                }
                            })
                            .catch(function (error) {
                                $eventbus.$emit('open:alert', 'Le formulaire comporte une erreur. Veuillez vérifier les informations.');
                            })
                            .then(function () {
                                self.clearConfirmPassword();
                            })
                }
            },
        }
    }
</script>

<style scoped>

</style>
